<template>
  <span :title="content"><slot /></span>
</template>

<script>
export default {
  name: 'CargoTooltip',
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>

</style>
